import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Group } from "@mantine/core";
import { FormattedMessage } from "react-intl";
import { useAppAction, useAppSelector } from "../../hooks/redux.js";
import { useCaptureEvent } from "../../components/StyleEditorContext.js";
import { memo, useCallback } from "react";
import { Event } from "../../constants/events.js";
import { getSourcesConfigDisplay, setSourcesConfigDisplay } from "../../reducers/sourcesReducer.js";
export const SourceConfigFooter = memo(() => {
    const captureEvent = useCaptureEvent();
    const currentDisplay = useAppSelector(getSourcesConfigDisplay);
    const changeDisplay = useAppAction(setSourcesConfigDisplay);
    const handleChangeDisplay = useCallback((display) => {
        captureEvent(Event.ChangeLayersConfigDisplay, {
            display,
        });
        changeDisplay(display);
    }, [changeDisplay, captureEvent]);
    return (_jsxs(Group, { gap: 8, children: [_jsx(Button, { flex: "1 0 0", variant: currentDisplay === "data" ? "filled" : "light", color: currentDisplay === "data" ? "dark" : "gray", radius: 6, fz: 14, ff: "monospace", onClick: () => {
                    handleChangeDisplay("data");
                }, children: _jsx(FormattedMessage, { id: "button.data", defaultMessage: "Data" }) }), _jsx(Button, { flex: "1 0 0", variant: currentDisplay === "code" ? "filled" : "light", color: currentDisplay === "code" ? "dark" : "gray", radius: 6, fz: 14, ff: "monospace", onClick: () => {
                    handleChangeDisplay("code");
                }, children: _jsx(FormattedMessage, { id: "button.code", defaultMessage: "Code" }) })] }));
});
SourceConfigFooter.displayName = "SourceConfigFooter";
